import { z } from 'zod';
/** Feedback to the Chapsi team from inside the app (docs/adr/0030-in-app-feedback.md). */
export const FeedbackKind = z.enum(['bug', 'idea', 'question']);
export const FEEDBACK_KINDS = {
    bug: { label: 'Something is wrong', prompt: 'What happened, and what did you expect?' },
    idea: { label: 'An idea', prompt: 'What would make this better for you?' },
    question: { label: 'A question', prompt: 'What would you like to know?' },
};
/** Up to three screenshots or files. */
export const MAX_FEEDBACK_FILES = 3;
export const SendFeedbackInput = z.object({
    kind: FeedbackKind,
    body: z.string().trim().min(1).max(5000),
    /** The path the person was on, without the query string or fragment (which can carry tokens). */
    page: z
        .string()
        .trim()
        .max(300)
        .transform((p) => p.split(/[?#]/)[0])
        .default(''),
    app: z.enum(['web', 'desktop', 'mobile']).default('web'),
    appVersion: z.string().trim().max(40).default(''),
    fileIds: z.array(z.uuid()).max(MAX_FEEDBACK_FILES).default([]),
});
//# sourceMappingURL=feedback.js.map